import { Flex, Heading, Text, View } from "@aws-amplify/ui-react";

export default function PrivacyPolicyPage() {
  return (
    <Flex
      direction="column"
      minWidth={650}
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex>
        <View>
          <Text>Last updated: August 29th, 2024</Text> <br/>
          <Text>
            Total Care Compass, LLC ("us", "we", or "our") operates the
            https://www.totalcarecompass.com website and the Total Care Compass portal
            https://main.d308vksn89hqfe.amplifyapp.com/ (the "Service").
          </Text>
          <Text>
            This page informs you of our policies regarding the collection, use
            and disclosure of Personal Information when you use our Service.
          </Text>
          <Text>
            We will not use or share your information with anyone except as
            described in this Privacy Policy.
          </Text>
          <Text>
            We use your Personal Information for providing and improving the
            Service. By using the Service, you agree to the collection and use
            of information in accordance with this policy. Unless otherwise
            defined in this Privacy Policy, terms used in this Privacy Policy
            have the same meanings as in our Terms and Conditions.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Information Collection And Use" />
          <Text>
            While using our Service, we may ask you to provide us with certain
            personally identifiable information that can be used to contact or
            identify you. Personally identifiable information may include, but
            is not limited to, your email address, name, phone number, postal
            address, other information ("Personal Information").
          </Text>
          <Text>
            We collect this information for the purpose of providing the
            Service, identifying and communicating with you, responding to your
            requests/inquiries, servicing your purchase orders, and improving
            our services.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Log Data" />
          <Text>
            We may also collect information that your browser sends whenever you
            visit our Service or when you access the Service by or through a
            mobile device ("Log Data").
          </Text>
          <Text>
            This Log Data may include information such as your computer's
            Internet Protocol ("IP") address, browser type, browser version, the
            pages of our Service that you visit, the time and date of your
            visit, the time spent on those pages and other statistics. It will
            NEVER include any of the data you store in Total Care Compass. Your data is
            stored in an encrypted database and stored in secure HIPAA compliant
            servers.
          </Text>
          <Text>
            When you access the Service by or through a mobile device, this Log
            Data may include information such as the type of mobile device you
            use, your mobile device unique ID, the IP address of your mobile
            device, your mobile operating system, the type of mobile Internet
            browser you use and other statistics.
          </Text>
          <Text>
            In addition, we may use third party services such as Google
            Analytics that collect, monitor and analyze this type of information
            mentioned above in order to increase our Service's functionality.
            These third party service providers have their own privacy policies
            addressing how they use such information. These services will NEVER
            include any of the data you store in Total Care Compass. Your data is
            stored in an encrypted database and stored in secure HIPAA compliant
            servers.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Cookies" />
          <Text>
            Cookies are files with a small amount of data, which may include an
            anonymous unique identifier. Cookies are sent to your browser from a
            web site and transferred to your device. We use cookies to collect
            information in order to improve our services for you.
          </Text>
          <Text>
            You can instruct your browser to refuse all cookies or to indicate
            when a cookie is being sent. The Help feature on most browsers
            provide information on how to accept cookies, disable cookies or to
            notify you when receiving a new cookie.
          </Text>
          <Text>
            If you do not accept cookies, you may not be able to use some
            features of our Service and we recommend that you leave them turned
            on.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Shared Data" />
          <Text>
            We value your privacy and will never share your health data without
            permission. Our goal is to allow you to gather your health
            information easily to enable you to better manage your care. We also
            want to provide you with an easy way to share information with
            research if you wish to contribute information to find cures faster.
          </Text>
          <Text>
            Total Care Compass is an “opt-in” platform. This means that you must give
            us permission before we share your data. For this, we provide a
            variety of opt-in categories to allow users to decide if and what
            they want to share. We never take data without permission from
            members. Your privacy is very important to us. We allow members to
            control the level and content of data sharing.
          </Text>
          <Text>
            If you decide to share your identifiable data at any point, we will
            provide a complete description of who you are sharing your data
            with, the specific data you are sharing, the timing of the sharing,
            and the purpose of the sharing before you confirm your consent to
            share. You will then be provided a method to electronically consent
            to share your data if desired.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Do Not Track Disclosure" />
          <Text>
            We support Do Not Track ("DNT"). Do Not Track is a preference you
            can set in your web browser to inform websites that you do not want
            to be tracked.
          </Text>
          <Text>
            You can enable or disable Do Not Track by visiting the Preferences
            or Settings page of your web browser.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Service Providers" />
          <Text>
            We may employ third party companies and individuals to facilitate
            our Service, to provide the Service on our behalf, to perform
            Service-related services and/or to assist us in analyzing how our
            Service is used.
          </Text>
          <Text>
            These third parties have access to your Personal Information only to
            perform specific tasks on our behalf and are obligated not to
            disclose or use your information for any other purpose.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Communications" />
          <Text>
            We may use your Personal Information to contact you with
            newsletters, marketing or promotional materials and other
            information that may be of interest to you. You may opt out of
            receiving any, or all, of these communications from us by following
            the unsubscribe link or instructions provided in any email we send.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Compliance With Laws" />
          <Text>
            We will disclose your Personal Information where required to do so
            by law or subpoena or if we believe that such action is necessary to
            comply with the law and the reasonable requests of law enforcement
            or to protect the security or integrity of our Service.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Security" />
          <Text>
            The security of your Personal Information is important to us, and we
            strive to implement and maintain reasonable, commercially acceptable
            security procedures and practices appropriate to the nature of the
            information we store, in order to protect it from unauthorized
            access, destruction, use, modification, or disclosure.
          </Text>
          <Text>
            However, please be aware that no method of transmission over the
            internet, or method of electronic storage is 100% secure and we are
            unable to guarantee the absolute security of the Personal
            Information we have collected from you.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="International Transfer" />
          <Text>
            Our secure HIPAA compliant servers are based in the United States.
          </Text>
          <Text>
            If you are located outside the United States and choose to provide
            information to us, please note that we transfer the information,
            including Personal Information, to the United States and process it
            there.
          </Text>
          <Text>
            Your consent to this Privacy Policy followed by your submission of
            such information represents your agreement to that transfer.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Links To Other Sites" />
          <Text>
            Our Service may contain links to other sites that are not operated
            by us. If you click on a third party link, you will be directed to
            that third party's site. We strongly advise you to review the
            Privacy Policy of every site you visit.
          </Text>
          <Text>
            We have no control over, and assume no responsibility for the
            content, privacy policies or practices of any third party sites or
            services.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Changes To This Privacy Policy" />
          <Text>
            This Privacy Policy is effective as of August 15, 2024 and will
            remain in effect except with respect to any changes in its
            provisions in the future, which will be in effect immediately after
            being posted on this page.
          </Text>
          <Text>
            We reserve the right to update or change our Privacy Policy at any
            time and you should check this Privacy Policy periodically. Your
            continued use of the Service after we post any modifications to the
            Privacy Policy on this page will constitute your acknowledgment of
            the modifications and your consent to abide and be bound by the
            modified Privacy Policy.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Contact Us" />
          <Text>
            If you have any questions about this Privacy Policy, please contact
            us at{"  "}
            <Text as="span" textDecoration={"underline"}>
              info@totalcarecompass.com
            </Text>
          </Text>
        </View>
      </Flex>
    </Flex>
  );
}
